/**
 * Return this similar list: 9, 8, ..., 1, ..., 1/8, 1/9
 * @returns {Array}
 */
export function getStaticWeights() {
    let weights = [];
    var i;
    for (i = 9; i >= 1; i--) {
        weights.push({ label: i, value: i });
    }
    for (i = 2; i <= 9; i++) {
        weights.push({ label: "1/" + i, value: "1/" + i });
    }
    return weights;
}

/**
 * Return mutual value
 * @param value
 * @returns {*}
 */
export function getMutualValue(value) {
    if (value.toString().indexOf('1/') === 0) {
        value = value.replace('1/', '');
    }
    else if (value !== '1') {
        value = '1/' + value;
    }
    return value;
}

function getAlternativeNames(values) {

    values.forEach(function (value, keyValue) {
        values[keyValue].alternatives = value.header;
    });

    values.push({ field: 'alternatives', header: '' });

    return values;
}

/**
 * Return dimension X of matrix
 * @param value
 * @returns {number}
 */
export function getMatrixDimensionX(value) {
    return value.length - 1;
}

/**
 * Encode values for editable table
 * @param data
 * @returns {*|Array}
 */
export function encodeMatrixTable(data) {
    var dataTable = [];
    var dataTableValues = [];

    var rankMatrix = data.labels.length;
    var cursorVector = 0;
    for (var i = 0; i < rankMatrix; i++) {
        dataTableValues.push({ 'field': i.toString(), 'header': data.labels[i] });
        for (var j = cursorVector; j < rankMatrix + cursorVector; j++) {
            dataTableValues[i][j - cursorVector] = data.values[j];
        }
        cursorVector = j
    }

    dataTable = getAlternativeNames(dataTableValues);
    return dataTable;
}

/**
 * Decode values from editable table
 * @param data
 * @returns {*|Array}
 */
export function decodeMatrixTable(data) {
    var labels = [];
    var values = [];
    var rankMatrix = data.length - 1;

    for (var i = 0; i < rankMatrix; i++) {
        labels.push(data[i].header);
        for (var j = 0; j < rankMatrix; j++) {
            values.push(String(data[i][j]));
        }
    }

    var dataMatrixValues = { 'labels': labels, 'values': values };
    var dataMatrix = { 'data': dataMatrixValues }

    return dataMatrix;
}

/**
 * Genera una matrice coerente.
 * La matrice coerente si geenra il base alla prima riga.
 * La formula da utilizzare è la reguente: i,j = 0,j/0,i
 * @param {*} data 
 */
export function getAutoQualitativeMatrix(data) {

    var labels = [];
    var rankMatrix = data.length - 1;
    var numerator;
    var denominator;

    for (var i = 1; i < rankMatrix; i++) {
        labels.push(data[i].header);
        for (var j = 0; j < rankMatrix; j++) {
            numerator = data[0][j];
            denominator = data[0][i];
            if (numerator === denominator) {
                data[i][j] = 1;
            }
            else {
                data[i][j] = getFraction(numerator, denominator);
            }
        }
    }

    return data;
}


/**
 * Restituisce il reciproco del valore
 * 
 * @param {*} numerator 
 * @param {*} denominator 
 */
function getFraction(numerator, denominator) {
    var value;
    var numeratorValues = numerator.split('/');
    var denominatorValues = denominator.split('/');

    if ((numeratorValues.length === 2) && (denominatorValues.length === 2)) {
        value = getHumanFraction(numeratorValues[0] * denominatorValues[1], numeratorValues[1] * denominatorValues[0]);
    }
    else if ((numeratorValues.length === 1) && (denominatorValues.length === 2)) {
        value = getHumanFraction(numeratorValues[0] * denominatorValues[1], denominatorValues[0]);
    }
    else if ((numeratorValues.length === 2) && (denominatorValues.length === 1)) {
        value = getHumanFraction(numeratorValues[0], numeratorValues[1] * denominatorValues[0]);
    }
    else if ((numeratorValues.length === 1) && (denominatorValues.length === 1)) {
        value = getHumanFraction(numeratorValues[0], denominatorValues[0]);
    }

    return value;
}

/**
 * Get human readble fraction
 * 
 * @param {*} numerator 
 * @param {*} denominator 
 */
function getHumanFraction(numerator, denominator) {
    if (denominator === '1') {
        return numerator;
    }
    else {
        return numerator + '/' + denominator;
    }
}



// WEBPACK FOOTER //
// ./src/utils/qualitativeMatrixUtils.js